import { Container } from './styles';

const Loading: React.FC = () => {
  return (
    <>
        <Container>
            <div className="lds-circle"><div></div></div>
            AGUARDE CARREGANDO
        </Container>
        
    </>
  );
}

export default Loading;